import { render, staticRenderFns } from "./TmPage.vue?vue&type=template&id=0a2c9cfc&scoped=true&"
import script from "./TmPage.vue?vue&type=script&lang=js&"
export * from "./TmPage.vue?vue&type=script&lang=js&"
import style0 from "./TmPage.vue?vue&type=style&index=0&id=0a2c9cfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2c9cfc",
  null
  
)

export default component.exports